import { getIn } from 'final-form';

import createSideEffectDecorator from 'common/forms/decorators/sideEffect';
import { REQUEST_RELATES } from 'ui/layout/ReportIssue/components/constants';

const updateKioskData = (contextType, values) => {
  if (contextType !== REQUEST_RELATES.KIOSK) {
    return undefined;
  }
  return getIn(values, 'context.kiosk');
};

const updateDeviceData = (contextType, values) => {
  if (contextType !== REQUEST_RELATES.MOBILE_APP) {
    return undefined;
  }
  return getIn(values, 'context.deviceName');
};

export const reportIssueSideEffectDecorator = createSideEffectDecorator([
  {
    field: 'context.type',
    updates: {
      'context.kiosk': updateKioskData,
      'context.deviceName': updateDeviceData
    }
  },
]);
